import React from 'react'
import { SECCION_TIPOS, getSeccionTipoLabel } from '../../constants/seccionTipos'

// Mapeo de tipo -> clase Tailwind bg-* (medium tone, NO el bg-100)
// Mantengo paleta consistente con getSeccionTipoColor pero un poco mas saturada
// para que la barra se lea bien.
const TIPO_BG = {
  calentamiento: 'bg-orange-400',
  hidratacion: 'bg-sky-400',
  tecnica: 'bg-purple-500',
  movilidad: 'bg-green-500',
  competitivo: 'bg-red-500',
  cierre: 'bg-gray-400',
  otro: 'bg-slate-400'
}

const getTipoBg = (tipo) => TIPO_BG[tipo] || 'bg-slate-300'

const ProgramaTiposBar = ({
  secciones = [],
  orientation = 'horizontal', // 'horizontal' | 'vertical'
  className = '',
  showLegend = true
}) => {
  const totalSeg = secciones.reduce((s, x) => s + (x.duracion_seg || 0), 0)
  if (totalSeg === 0 || secciones.length === 0) {
    return null
  }

  // Agrupar por tipo (suma de duracion por tipo para la leyenda)
  const tiposPresentes = secciones.reduce((acc, s) => {
    if (!acc[s.tipo]) acc[s.tipo] = 0
    acc[s.tipo] += s.duracion_seg || 0
    return acc
  }, {})

  // Para la barra: cada seccion individual (no agrupada) para reflejar el orden real
  const segments = secciones.map((s) => ({
    tipo: s.tipo,
    porcentaje: ((s.duracion_seg || 0) / totalSeg) * 100,
    nombre: s.nombre
  }))

  if (orientation === 'vertical') {
    return (
      <div className={`flex flex-col ${className}`}>
        <div className="flex-1 flex flex-col w-3 rounded-full overflow-hidden bg-muted min-h-[60px]">
          {segments.map((seg, idx) => (
            <div
              key={idx}
              className={`${getTipoBg(seg.tipo)} transition-colors`}
              style={{ height: `${seg.porcentaje}%` }}
              title={`${seg.nombre} · ${getSeccionTipoLabel(seg.tipo)}`}
            />
          ))}
        </div>
      </div>
    )
  }

  // Horizontal
  return (
    <div className={className}>
      <div
        className="flex h-2 w-full rounded-full overflow-hidden bg-muted"
        role="img"
        aria-label="Distribucion de tipos de seccion"
      >
        {segments.map((seg, idx) => (
          <div
            key={idx}
            className={`${getTipoBg(seg.tipo)} transition-colors`}
            style={{ width: `${seg.porcentaje}%` }}
            title={`${seg.nombre} · ${getSeccionTipoLabel(seg.tipo)}`}
          />
        ))}
      </div>
      {showLegend && (
        <div className="mt-1.5 flex flex-wrap gap-x-2 gap-y-0.5 text-[10px] text-muted-foreground">
          {Object.entries(tiposPresentes).map(([tipo, seg]) => {
            const pct = Math.round((seg / totalSeg) * 100)
            return (
              <span key={tipo} className="flex items-center gap-1 whitespace-nowrap">
                <span className={`inline-block h-1.5 w-1.5 rounded-full ${getTipoBg(tipo)}`} />
                {getSeccionTipoLabel(tipo)} {pct}%
              </span>
            )
          })}
        </div>
      )}
    </div>
  )
}

export default ProgramaTiposBar
